/**
 * details-reason — `details.reason` 的取值比对（**含一次性过渡期兼容，下个发布周期删**）
 *
 * dev-docs#1008（dd-issue1005）把 `details.reason` 统一成 UPPER_SNAKE_CASE，server 与 web 在同一个
 * PR 里切。但**这次切换在时间上不可能原子**，两个方向各有一个窗口：
 *
 *  ① 根 `package.json` 的 `deploy:prod` 是 `web deploy:prod && server deploy:prod` —— **web 先上**。
 *     这段窗口里新前端遇到的是仍发小写的旧服务端。
 *  ② server 发完之后，运营**已经打开着的旧标签页**跑的还是旧 bundle，遇到的是已发大写的新服务端。
 *
 * 两个窗口里「两级判据」（`code` + `details.reason`）都会落空，退化成通用冲突文案 —— 而落点页那条
 * 判据一旦落空还会连带走进 `invalidate` 分支，把运营正在编辑的草稿清掉
 * （见 `~/data/use-ops-shelf-popup` 的 `invalidateUnlessStaleSnapshot`）。
 *
 * 故过渡期按**大小写不敏感**比对：① 由本模块直接消解；② 是旧 bundle、本模块救不了（旧 JS 已经发出去
 * 了），只能靠发版后让运营刷新一次。
 *
 * 🔻 **删除条件**：下一个发布周期（线上 server 与所有活跃标签页都已是大写之后）删掉本模块，
 * 各调用点判据改回全等比较。留着不删会让「服务端哪天又退回小写」这类真回归被静默吞掉。
 */

/**
 * `details.reason` 是否等于 `expected`（**过渡期大小写不敏感**）。
 *
 * `expected` 传 UPPER_SNAKE_CASE 的目标值；非字符串 reason（缺字段 / 被塞了对象）一律返 false。
 */
export function detailsReasonIs(details: unknown, expected: string): boolean {
  const raw = (details as { reason?: unknown } | undefined)?.reason;
  return typeof raw === 'string' && raw.toUpperCase() === expected;
}
